import {
    Dialog,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Input,
    Select,
    Option,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Popover,
    Tabs,
    TabPane,
    Row,
    Col,
    Progress,
    Card,
    Steps,
    Step,
    Collapse,
    CollapseItem,
    Container,
    Header,
    Aside,
    Main,
    Loading,
    MessageBox,
    Message,
    Notification,
    Table,
    TableColumn,
    Scrollbar,
    Pagination,
    Button,
    Form,
    FormItem,
    Radio,
    RadioGroup
  } from 'element-ui';

  const element = {
    install: function (Vue) {
      Vue.use(Dialog);
      Vue.use(Dropdown);
      Vue.use(DropdownMenu);
      Vue.use(DropdownItem);
      Vue.use(Input);
      Vue.use(Select);
      Vue.use(Option);
      Vue.use(Checkbox);
      Vue.use(CheckboxButton);
      Vue.use(CheckboxGroup);
      Vue.use(Popover);
      Vue.use(Tabs);
      Vue.use(TabPane);
      Vue.use(Row);
      Vue.use(Col);
      Vue.use(Progress);
      Vue.use(Card);
      Vue.use(Steps);
      Vue.use(Step);
      Vue.use(Collapse);
      Vue.use(CollapseItem);
      Vue.use(Container);
      Vue.use(Header);
      Vue.use(Aside);
      Vue.use(Main);

      Vue.use(Loading.directive);
      Vue.use(Table);
      Vue.use(TableColumn);
      Vue.use(Scrollbar);
      Vue.use(Pagination);
      Vue.use(Button);
      Vue.use(Form);
      Vue.use(FormItem);
      Vue.use(Radio);
      Vue.use(RadioGroup);

      Vue.prototype.$loading = Loading.service;
      Vue.prototype.$msgbox = MessageBox;
      Vue.prototype.$alert = MessageBox.alert;
      Vue.prototype.$confirm = MessageBox.confirm;
      Vue.prototype.$prompt = MessageBox.prompt;
      Vue.prototype.$notify = Notification;
      Vue.prototype.$message = Message;
    }
  }

  export default element



// WEBPACK FOOTER //
// ./src/element.js